import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreLoaderService {
  private static _loaders:Array<Promise<any>> = [];

  public static registerLoader(method:Promise<any>):void {
    PreLoaderService._loaders.push(method);
  }

  public static clear():void {
    PreLoaderService._loaders = [];
  }

  public static load():Promise<any> {
    return new Promise((resolve, reject) => {
      PreLoaderService._executeAll(resolve);
    });
  }

  private static _executeAll(done:Function):void {
    setTimeout(() => {
      Promise.all(PreLoaderService._loaders).then((values) => {
        done.call(null, values);

      }).catch((error) => {
        console.error(error);
      });
    });
  }
  }
